import "./SingleChannel.css";
import "./RelatedChannels.css";
import Container from "react-bootstrap/Container";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import SingleChannelHero from "./SingleChannelHero";
import SingleChannelNav from "./SingleChannelNav";
import ChannelVideos from "./ChannelVideos";
import { useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  campaignFetcher,
  channelFetcher,
  viewsFetcher,
} from "../../api/requests";
import Playlist from "./Playlist";
import RelatedChannels from "./RelatedChannels";

const SingleChannel = () => {
  const { id } = useParams();
  const location = useLocation();
  const [channel, setChannel] = useState();
  const [navOption, setNavOption] = useState("videos");
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const [loading, setLoading] = useState(true);
  const [relatedChannels, setRelatedChannels] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);

  useEffect(() => {
    const getChannel = async () => {
      try {
        const channelData = campaignId
          ? await campaignFetcher.getEachCampaign(Number(id))
          : await channelFetcher.getEachChannel(Number(id));

        setChannel(channelData);
      } catch (err) {
        console.error("Error fetching channel data:", err);
      }
    };

    getChannel();
  }, [id, campaignId]);

  useEffect(() => {
    if (location.hash === "#playlistCreation") {
      setNavOption("playlist");
    }

    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (!id) return;

    let isMounted = true;
    const fetchRelatedChannels = async () => {
      setLoading(true);
      try {
        const [res1, res2] = await Promise.all([
          channelFetcher.getRelatedChannels({
            pageSize: 10000,
            fromChannelId: id,
            is_hidden_for_from: false,
          }),
          channelFetcher.getRelatedChannels({
            pageSize: 10000,
            toChannelId: id,
            is_hidden_for_to: false,
          }),
        ]);

        const combined = [...(res1?.results || []), ...(res2?.results || [])];
        const uniqueRelations = Array.from(
          new Map(combined.map((r) => [r.id, r])).values()
        );

        if (isMounted) {
          setRelatedChannels(uniqueRelations);
        }
      } catch (error) {
        console.error("Error fetching related channels:", error);
        if (isMounted) {
          setRelatedChannels([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    !campaignId && fetchRelatedChannels();

    return () => {
      isMounted = false;
    };
  }, [id]);

  return (
    <>
      <ContentWrapper className="single-channel-page">
        <SingleChannelHero channel={channel} id={id} />
        <SingleChannelNav
          setNavOption={setNavOption}
          navOption={navOption}
          channel={channel}
          campaign={campaignId}
          showRelatedChannels={relatedChannels?.length}
          setSearchText={setSearchText}
        />
        <Container fluid>
          <div className="single-channel-content-wrapper">
            <div className="single-channel-main-content">
              {navOption === "videos" && (
                <ChannelVideos
                  id={Number(id)}
                  campaign={campaignId ? true : false}
                  videoCount={channel?.total_video_count}
                  searchText={searchText}
                />
              )}
              {navOption === "relatedChannels" && (
                <RelatedChannels
                  currentChannelId={Number(id)}
                  relatedChannels={relatedChannels}
                  loading={loading}
                />
              )}
              {navOption === "playlist" && <Playlist id={id} />}
              {navOption === "about" && (
                <p
                  style={{
                    textAlign: "right",
                    minHeight: "120px",
                    paddingRight: "30px",
                    paddingTop: "30px",
                    whiteSpace: "pre-line",
                  }}
                >
                  {channel?.description}
                </p>
              )}
            </div>
          </div>
        </Container>
      </ContentWrapper>

      <ThinFooter />
    </>
  );
};

export default SingleChannel;
